import React from 'react';
import { Provider } from 'react-redux';

import { loadContainers } from '@eika-infrastruktur/render';

import { loadConfig } from './actions';
import CustomAppTypes from './config/customAppTypes';
import resolveLocalConfigData from './config/localFallbackData';
import configureStore from './configure-store';
import App from './containers/App';
import { initialState } from './reducers/context';
import Routes from './routes';

import './styles/main.scss';

const store = configureStore();
const defaultNamespace = 'securedloan';
const { defaultAppType } = initialState;
const nameSpaceStart = `${defaultNamespace}.`;

const renderApp = (namespace: string) => {
    loadContainers(namespace, ({ config }) => {
        const namespaceContainsAppType = namespace.length > defaultNamespace.length;
        const appType = namespaceContainsAppType ? namespace.substring(nameSpaceStart.length) : defaultAppType;
        const localConfigData = resolveLocalConfigData(appType, defaultAppType);
        // @ts-ignore
        store.dispatch(loadConfig(config, localConfigData, appType));

        return (
            <div className="sgw-content kredittbank-securedloan-application-web" id="app-container">
                <Provider store={store}>
                    <App>
                        <Routes />
                    </App>
                </Provider>
            </div>
        );
    });
};

const renderApps = () => {
    renderApp(defaultNamespace);
    CustomAppTypes.all().forEach((customAppType: string) => renderApp(`${defaultNamespace}.${customAppType}`));
};

renderApps();
